<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/products">Products</router-link></li>
        <template v-if="update == true">
          <li><router-link v-bind:to="`/products/${this.$route.params.product_id}`">{{ this.$store.state.product.name }}</router-link></li>
          <li class="is-active"><a href="#" aria-current="page">Edit product name</a></li>
        </template>
        <li v-else class="is-active"><a href="#" aria-current="page">Create a new product</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-6 is-offset-3" v-on:keyup.enter="submit">
        <div class="field">
          <label class="label">Product name</label>
          <div class="control">
            <input
              name="name"
              type="text"
              placeholder="Product name"
              v-model="fields.name"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('name') }"
              v-on:input="fields.slug = slug(fields.name, {lower: true})"
              v-validate="'required'"
              data-vv-as="Product name">
          </div>
          <span v-show="veeErrors.has('name')" class="help is-danger">{{ veeErrors.first('name') }}</span>
        </div>

        <div class="field" v-if="update == false">
          <label class="label">Slug</label>
          <div class="control">
            <input
              name="slug"
              type="text"
              placeholder="product-slug"
              v-model="fields.slug"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('slug') }"
              v-validate="'required|regex:^[a-z0-9]+(?:-[a-z0-9]+)*$'"
              data-vv-as="Product slug">
          </div>
          <span v-show="veeErrors.has('slug')" class="help is-danger">{{ veeErrors.first('slug') }}</span>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button v-bind:class="{ 'button': true, 'is-primary': true, 'is-loading': isLoading }" v-on:click="submit">Submit</button>
          </div>
          <div class="control">
            <router-link v-bind:to="cancelUrl" class="button" exact>Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import slug from 'slug'

  export default {
    data () {
      return {
        fields: {
          organization_id: this.$store.state.organizationId,
          name: '',
          slug: ''
        },
        isLoading: false
      }
    },

    computed: {
      cancelUrl () {
        return this.update ? `/products/${this.$route.params.product_id}` : `/products`
      }
    },

    methods: {
      submit () {
        this.$validator.validateAll().then((passed) => {
          if (!passed) {
            return
          }

          this.isLoading = true

          this.createOrUpdateProduct(this.$route.params.product_id, this.fields)
            .then(() => {
              this.$router.push(`/products/${this.$store.state.product.id}`)
            })
            .catch(() => {
              // Add server errors into the existing ErrorBag object
              if (this.$store.state.error.response) {
                Object.keys(this.$store.state.error.response.data.error.validation_errors).forEach(key => {
                  this.veeErrors.add(key, this.$store.state.error.response.data.error.validation_errors[key][0])
                })
              }

              this.isLoading = false
            })
        })
      },

      createOrUpdateProduct (productId, params) {
        // Don't send disabled fields
        // TODO: improve
        if (productId) {
          delete params.slug
        }

        return productId
          ? this.$store.dispatch('updateProduct', { productId, params })
          : this.$store.dispatch('createProduct', params)
      }
    },

    // Make slug available in the template
    beforeCreate () {
      this.slug = slug
    },

    created () {
      if (this.update) {
        this.$store.dispatch('getProduct', {
          productId: this.$route.params.product_id
        })
          .then(() => {
            this.fields = {
              name: this.$store.state.product.name,
              slug: this.$store.state.product.slug
            }
          })
      }
    },

    props: ['update']
  }
</script>



// WEBPACK FOOTER //
// ProductForm.vue?67745771